import { jsx, jsxs } from "react/jsx-runtime";
import { Popover } from "@base-ui/react/popover";
import react from "react";
import { cn } from "../../utils/index.js";
import { CdnIcon } from "../CdnIcon/index.js";
import { IconButton } from "../IconButton/index.js";
import { ValidTooltipColorValues, tooltipVariants } from "./Tooltip.variants.js";
function Tooltip(props) {
    const { children, triggerNode, isNativeTriggerNodeButton = false, iconLeft, positionMethod = 'fixed', color = 'neutral', align = 'center', side = 'bottom', showArrow = false, sideOffset = 10, alignOffset = 0, width = 'auto', emphasis = 'bold', openOnHover = true, open, defaultOpen = false, onOpenChange, hideCloseButton = false, className, slots = {
        triggerSlot: '',
        baseSlot: '',
        iconSlot: '',
        arrowContainerSlot: '',
        arrowSlot: '',
        containerSlot: '',
        contentSlot: '',
        positionerSlot: ''
    }, ariaLabel } = props;
    const { baseSlot, iconSlot, triggerSlot, arrowContainerSlot, arrowSlot, containerSlot, contentSlot, positionerSlot } = tooltipVariants({
        color,
        emphasis,
        showArrow,
        width
    });
    const triggerClasses = cn(triggerSlot(), className, slots.triggerSlot);
    const baseSlotClasses = cn(baseSlot(), slots.baseSlot);
    const iconSlotClasses = cn(iconSlot(), slots.iconSlot);
    const arrowContainerClasses = cn(arrowContainerSlot(), slots.arrowContainerSlot);
    const arrowClasses = cn(arrowSlot(), slots.arrowSlot);
    const containerSlotClasses = cn(containerSlot(), slots.containerSlot);
    const contentSlotClasses = cn(contentSlot(), slots.contentSlot);
    const positionerSlotClasses = cn(positionerSlot(), slots.positionerSlot);
    const triggerNodeRenderer = (props)=>{
        if (!triggerNode) return /*#__PURE__*/ jsx("span", {});
        return /*#__PURE__*/ react.cloneElement(triggerNode, {
            ...props,
            ...triggerNode.props
        });
    };
    const popupContent = /*#__PURE__*/ jsx(Popover.Portal, {
        children: /*#__PURE__*/ jsx(Popover.Positioner, {
            align: align,
            side: side,
            sideOffset: sideOffset,
            alignOffset: alignOffset,
            arrowPadding: 16,
            className: positionerSlotClasses,
            positionMethod: positionMethod,
            children: /*#__PURE__*/ jsxs(Popover.Popup, {
                className: baseSlotClasses,
                "data-testid": "tooltip",
                "aria-label": ariaLabel,
                children: [
                    /*#__PURE__*/ jsx(Popover.Arrow, {
                        className: arrowContainerClasses,
                        children: /*#__PURE__*/ jsx("div", {
                            className: arrowClasses,
                            "data-testid": "tooltip-arrow"
                        })
                    }),
                    /*#__PURE__*/ jsxs("div", {
                        className: containerSlotClasses,
                        children: [
                            /*#__PURE__*/ jsxs("div", {
                                className: contentSlotClasses,
                                children: [
                                    iconLeft && /*#__PURE__*/ jsx(CdnIcon, {
                                        iconName: iconLeft,
                                        className: iconSlotClasses,
                                        size: "16"
                                    }),
                                    children
                                ]
                            }),
                            !hideCloseButton && /*#__PURE__*/ jsx(Popover.Close, {
                                render: (props)=>/*#__PURE__*/ jsx(IconButton, {
                                        ...props,
                                        iconName: "close",
                                        type: "plainSecondary",
                                        emphasis: emphasis,
                                        size: "3xs",
                                        "aria-label": "Close tooltip"
                                    })
                            })
                        ]
                    })
                ]
            })
        })
    });
    return /*#__PURE__*/ jsxs(Popover.Root, {
        defaultOpen: defaultOpen,
        open: open,
        onOpenChange: onOpenChange,
        children: [
            /*#__PURE__*/ jsx(Popover.Trigger, {
                openOnHover: openOnHover,
                render: triggerNodeRenderer,
                nativeButton: isNativeTriggerNodeButton,
                className: triggerClasses
            }),
            popupContent
        ]
    });
}
export { Tooltip, ValidTooltipColorValues };
